import { Model } from "@vuex-orm/core"

export default class Video extends Model {
  static entity = "videos"

  static fields() {
    return {
      id: this.string(""),
      description: this.string(""),
      url: this.string(""),
      pos: this.number(0),
    }
  }

  id!: string
  description!: string
  url!: string
  pos!: number
}
